import { modals } from '@mantine/modals'
import { Text } from '@mantine/core'

export function confirmDelete(
  message: string,
  onConfirm: () => void | Promise<void>,
  title = 'Устгахдаа итгэлтэй байна уу?'
) {
  modals.openConfirmModal({
    title,
    children: <Text size="sm">{message}</Text>,
    labels: { confirm: 'Устгах', cancel: 'Болих' },
    confirmProps: { color: 'red' },
    onConfirm,
  })
}

export function confirmAction(
  message: string,
  onConfirm: () => void | Promise<void>,
  opts?: { title?: string; confirmLabel?: string; color?: string }
) {
  modals.openConfirmModal({
    title: opts?.title ?? 'Үргэлжлүүлэх үү?',
    children: <Text size="sm">{message}</Text>,
    labels: { confirm: opts?.confirmLabel ?? 'Тийм', cancel: 'Болих' },
    confirmProps: { color: opts?.color ?? 'blue' },
    onConfirm,
  })
}
